module.exports = __webpack_public_path__ + "img/healthy.919ade88.svg";